namespace Matrix.Workflow {
    export namespace ApprovalQueueService {
        export const baseUrl = 'Workflow/ApprovalQueue';

        export declare function Retrieve(request: ApprovalRetrieveRequest, onSuccess?: (response: ApprovalRetrieveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Approve(request: ApprovalRequest, onSuccess?: (response: ApprovalResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: WorkflowInstanceListRequest, onSuccess?: (response: Serenity.ListResponse<WorkflowInstanceRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Workflow/ApprovalQueue/Retrieve",
            Approve = "Workflow/ApprovalQueue/Approve",
            List = "Workflow/ApprovalQueue/List"
        }

        [
            'Retrieve', 
            'Approve', 
            'List'
        ].forEach(x => {
            (<any>ApprovalQueueService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
